// extracted by mini-css-extract-plugin
module.exports = {"name":"formatters_name__2EBK-","totalPrice":"formatters_totalPrice__3nchg"};